import { useState, useEffect, CSSProperties } from "react";

const SUPABASE_URL = 'https://szbwqnllhhsawebwhrwj.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN6YndxbmxsaGhzYXdlYndocndqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI1MDAzNDgsImV4cCI6MjA4ODA3NjM0OH0.hRIxkoL41qrAYKaVt1iND9ZjILyDpAM5k0TG8lfqKrQ';

const T = {
  gold: "#C8A84B", goldMuted: "#9A7A35", goldDim: "#6A5A25",
  cream: "#F5F0E8", creamMuted: "#C8B89A", copper: "#8B6B4A",
  copperLight: "#B08A60", ink: "#0A0806", surface: "#120E0A",
  surfaceRaised: "#1A1410", border: "#251810", borderMid: "#3A2A18",
  burgundyLight: "#8B2A2A", green: "#6AB06A", greenDim: "#3A5A3A",
} as const;

const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=Crimson+Pro:ital,wght@0,200;0,300;0,400;1,200;1,300&family=Josefin+Sans:wght@100;200;300&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #0A0806; color: #F5F0E8; font-family: 'Crimson Pro', Georgia, serif; -webkit-font-smoothing: antialiased; }
  @keyframes fadeUp { from { opacity: 0; transform: translateY(22px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes pulse { 0%, 100% { opacity: 0.35; } 50% { opacity: 1; } }
  .anim-fade-up { animation: fadeUp 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) both; }
  .ex-tab { background: none; border: none; border-bottom: 2px solid transparent; cursor: pointer; font-family: 'Josefin Sans', sans-serif; font-weight: 200; font-size: 10px; letter-spacing: 0.35em; text-transform: uppercase; color: #8B6B4A; padding: 12px 20px 14px; transition: all 0.25s ease; }
  .ex-tab.active { border-bottom-color: #9A7A35; color: #C8B89A; }
  .ex-tab:hover { color: #C8B89A; }
  .ex-card { background: #120E0A; border: 1px solid #251810; padding: 24px 28px; transition: border-color 0.3s ease; }
  .ex-card:hover { border-color: #3A2A18; }
  .ex-btn { background: none; border: 1px solid #3A2A18; color: #9A7A35; font-family: 'Josefin Sans', sans-serif; font-weight: 200; font-size: 9px; letter-spacing: 0.3em; text-transform: uppercase; padding: 7px 16px; cursor: pointer; transition: all 0.25s ease; }
  .ex-btn:hover { border-color: #9A7A35; color: #C8A84B; }
  .ex-btn-gold { background: #9A7A35; border: 1px solid #C8A84B; color: #0A0806; font-family: 'Josefin Sans', sans-serif; font-weight: 300; font-size: 9px; letter-spacing: 0.35em; text-transform: uppercase; padding: 9px 22px; cursor: pointer; transition: all 0.3s ease; }
  .ex-btn-gold:hover { background: #C8A84B; }
  .ex-btn-gold:disabled { opacity: 0.38; cursor: not-allowed; }
  .ex-pill { display: inline-block; font-family: 'Josefin Sans', sans-serif; font-weight: 100; font-size: 8px; letter-spacing: 0.25em; text-transform: uppercase; padding: 3px 10px; border: 1px solid #3A2A18; color: #8B6B4A; }
  .ex-pill.open { border-color: #9A7A35; color: #C8A84B; }
  .ex-pill.applied { border-color: #9A7A35; color: #C8A84B; }
  .ex-pill.booked { border-color: #3A5A3A; color: #6AB06A; }
  .ex-pill.confirmed { border-color: #3A5A3A; color: #6AB06A; }
  .ex-pill.completed { border-color: #3A5A3A; color: #6AB06A; }
  .ex-pill.cancelled { border-color: #3A1010; color: #8B2A2A; }
  .ex-pill.no_show { border-color: #3A1010; color: #8B2A2A; }
  .sl-input { width: 100%; background: transparent; border: none; border-bottom: 1px solid #2A1A14; color: #F5F0E8; font-family: 'Crimson Pro', Georgia, serif; font-size: 16px; font-weight: 300; padding: 10px 0; outline: none; caret-color: #B08A60; transition: border-color 0.35s ease; }
  .sl-input::placeholder { color: #4A3020; font-style: italic; }
  .sl-input:focus { border-bottom-color: #8B6B4A; }
  .sl-select { width: 100%; background: #120E0A; border: none; border-bottom: 1px solid #2A1A14; color: #F5F0E8; font-family: 'Josefin Sans', sans-serif; font-size: 11px; font-weight: 200; letter-spacing: 0.15em; padding: 10px 0; outline: none; cursor: pointer; appearance: none; transition: border-color 0.35s ease; }
  .sl-select:focus { border-bottom-color: #8B6B4A; }
  .sl-select option { background: #1A1008; }

  html, body, #root {
    width: 100%;
    min-height: 100%;
    overflow-x: hidden;
  }

  @media (max-width: 768px) {
    .ex-dashboard-nav {
      padding: 0 16px !important;
    }

    .ex-dashboard-nav-inner {
      height: auto !important;
      min-height: 64px !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 10px !important;
      padding: 12px 0 !important;
    }

    .ex-dashboard-nav-actions {
      width: 100% !important;
      justify-content: space-between !important;
      gap: 12px !important;
      overflow: visible !important;
      flex-wrap: nowrap !important;
    }

    .ex-dashboard-nav-actions span {
      max-width: calc(100% - 125px) !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      display: block !important;
    }

    .ex-sign-out {
      flex-shrink: 0 !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .ex-dashboard-shell {
      padding: 128px 16px 56px !important;
      width: 100% !important;
    }

    .ex-stats-grid {
      grid-template-columns: 1fr !important;
      margin-bottom: 32px !important;
    }

    .ex-tabs {
      overflow-x: auto !important;
      white-space: nowrap !important;
      margin-bottom: 32px !important;
      -webkit-overflow-scrolling: touch;
    }

    .ex-tab {
      flex-shrink: 0 !important;
      padding: 12px 16px 14px !important;
      letter-spacing: 0.22em !important;
    }

    .ex-card-row {
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 18px !important;
    }

    .ex-card-action {
      width: 100% !important;
    }

    .ex-card-action button,
    .ex-btn-gold {
      width: 100% !important;
    }

    .ex-form-grid {
      grid-template-columns: 1fr !important;
      gap: 24px !important;
    }

    .ex-card {
      padding: 20px 18px !important;
    }
  }
`;

function getUser() {
  try {
    return JSON.parse(localStorage.getItem('sl_user') || 'null');
  } catch {
    return null;
  }
}

function getToken() {
  return localStorage.getItem('sl_token') || '';
}

function extractRate(tierRequired: string): number {
  const match = tierRequired.match(/\$(\d+)/);
  return match ? parseInt(match[1], 10) : 0;
}

function PayoutBadge({ tierRequired }: { tierRequired: string }) {
  const rate = extractRate(tierRequired);
  if (!rate) return null;

  return (
    <div style={{ marginTop: 12, display: 'inline-flex', alignItems: 'center', gap: 10, padding: '6px 14px', border: '1px solid #3A5A3A', background: '#0E0C06' }}>
      <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 8, letterSpacing: '0.3em', textTransform: 'uppercase', color: '#6AB06A' }}>Your Payout</span>
      <span style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 20, color: '#C8A84B', lineHeight: 1 }}>${rate}</span>
      <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 8, letterSpacing: '0.2em', color: '#6AB06A' }}>full payout · beta period</span>
    </div>
  );
}

function Eyebrow({ children }: { children: React.ReactNode }) {
  return <p style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 9, letterSpacing: "0.5em", textTransform: "uppercase", color: T.goldMuted, marginBottom: 10 }}>{children}</p>;
}

function StatCard({ label, value, sub }: { label: string; value: string; sub?: string }) {
  return (
    <div style={{ background: T.surface, border: `1px solid ${T.border}`, padding: "20px 24px" }}>
      <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 8, letterSpacing: "0.4em", textTransform: "uppercase", color: T.copper, marginBottom: 8 }}>{label}</div>
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 32, color: T.cream, lineHeight: 1 }}>{value}</div>
      {sub && <div style={{ fontFamily: "'Crimson Pro', serif", fontSize: 13, color: T.copper, fontStyle: "italic", marginTop: 6 }}>{sub}</div>}
    </div>
  );
}

function LabelStyle(): CSSProperties {
  return {
    display: 'block',
    fontFamily: "'Josefin Sans', sans-serif",
    fontWeight: 100,
    fontSize: 9,
    letterSpacing: '0.4em',
    textTransform: 'uppercase',
    color: T.copper,
    marginBottom: 8
  };
}

interface Event {
  id: string;
  title: string;
  event_date: string;
  location_name: string;
  city: string;
  state: string;
  product_category: string;
  tier_required: string;
  duration_hours: number;
  notes: string;
  status: string;
  producer_id: string;
}

interface Booking {
  id: string;
  event_id: string;
  status: string;
  compliance_pdf_url?: string;
  events?: Event;
}

interface Producer {
  id: string;
  company_name?: string;
  email?: string;
}

const EMPTY_REPORT = {
  event_completed: false,
  actual_start_time: '',
  actual_end_time: '',
  cases_sold: '',
  bottles_sold: '',
  samples_poured: '',
  estimated_attendance: '',
  skus_poured: '',
  top_performing_sku: '',
  competitor_products: '',
  retailer_staff_engagement: '',
  followup_recommended: false,
  followup_notes: '',
  store_manager_name: '',
  store_manager_confirmed: false,
  expert_notes: '',
  expert_rating_of_event: '',
};

export default function ExpertDashboard() {
  const [view, setView] = useState<'browse' | 'bookings' | 'matches' | 'reports' | 'profile'>('browse');
  const [events, setEvents] = useState<Event[]>([]);
  const [bookings, setBookings] = useState<Booking[]>([]);
  const [matchedProducers, setMatchedProducers] = useState<Producer[]>([]);
  const [loading, setLoading] = useState(true);
  const [applying, setApplying] = useState<string | null>(null);
  const [applySuccess, setApplySuccess] = useState<string | null>(null);
  const [profileForm, setProfileForm] = useState({ full_name: '', bio: '', specialties: '' });
  const [profileSaving, setProfileSaving] = useState(false);
  const [profileMsg, setProfileMsg] = useState('');
  const [stripeConnecting, setStripeConnecting] = useState(false);
  const [reportBooking, setReportBooking] = useState<Booking | null>(null);
  const [reportForm, setReportForm] = useState({ ...EMPTY_REPORT });
  const [reportSubmitting, setReportSubmitting] = useState(false);
  const [reportMsg, setReportMsg] = useState('');

  useEffect(() => {
    const tag = document.createElement('style');
    tag.innerHTML = GLOBAL_CSS;
    document.head.appendChild(tag);
    return () => { document.head.removeChild(tag); };
  }, []);

  useEffect(() => {
    const user = getUser();
    if (!user) {
      window.location.href = '/login';
      return;
    }

    fetchAll();
  }, []);

  const fetchAll = async () => {
    setLoading(true);
    await Promise.all([
      fetchOpenEvents(),
      fetchMyBookings(),
      fetchMatchedProducers(),
      fetchProfile(),
    ]);
    setLoading(false);
  };

  const fetchCurrentExpert = async () => {
    const user = getUser();
    const token = getToken();

    if (!user?.id) return null;

    const res = await fetch(
      `${SUPABASE_URL}/rest/v1/experts?user_id=eq.${user.id}&select=id,base_rate&limit=1`,
      {
        headers: {
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${token}`,
        },
      }
    );

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.message || data.error || 'Failed to fetch expert profile.');
    }

    return Array.isArray(data) ? data[0] : null;
  };

  const fetchOpenEvents = async () => {
    const token = getToken();

    try {
      const res = await fetch(`${SUPABASE_URL}/rest/v1/events?status=eq.open&order=event_date.asc`, {
        headers: {
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${token}`,
        },
      });

      const data = await res.json();
      setEvents(Array.isArray(data) ? data : []);
    } catch {
      setEvents([]);
    }
  };

  const fetchMyBookings = async () => {
    const token = getToken();

    try {
      const expert = await fetchCurrentExpert();

      if (!expert) {
        setBookings([]);
        return;
      }

      const bookingsRes = await fetch(
        `${SUPABASE_URL}/rest/v1/bookings?expert_id=eq.${expert.id}&select=*&order=created_at.desc`,
        {
          headers: {
            'apikey': SUPABASE_ANON_KEY,
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      const bookingsData = await bookingsRes.json();

      if (!bookingsRes.ok) {
        console.error('Failed to fetch bookings:', bookingsData);
        setBookings([]);
        return;
      }

      if (!Array.isArray(bookingsData) || bookingsData.length === 0) {
        setBookings([]);
        return;
      }

      const eventIds = bookingsData
        .map((booking) => booking.event_id)
        .filter(Boolean);

      if (eventIds.length === 0) {
        setBookings(bookingsData);
        return;
      }

      const eventsRes = await fetch(
        `${SUPABASE_URL}/rest/v1/events?id=in.(${eventIds.join(',')})&select=*`,
        {
          headers: {
            'apikey': SUPABASE_ANON_KEY,
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      const eventsData = await eventsRes.json();

      if (!eventsRes.ok) {
        console.error('Failed to fetch booking events:', eventsData);
        setBookings(bookingsData);
        return;
      }

      const eventsById = new Map(
        Array.isArray(eventsData)
          ? eventsData.map((event) => [event.id, event])
          : []
      );

      const bookingsWithEvents = bookingsData.map((booking) => ({
        ...booking,
        events: eventsById.get(booking.event_id) || null,
      }));

      setBookings(bookingsWithEvents);
    } catch (err) {
      console.error('Failed to fetch my bookings:', err);
      setBookings([]);
    }
  };

  const fetchMatchedProducers = async () => {
    const token = getToken();

    try {
      const res = await fetch(`${SUPABASE_URL}/rest/v1/producers?select=id,company_name,email&limit=20`, {
        headers: {
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${token}`,
        },
      });

      const data = await res.json();
      setMatchedProducers(Array.isArray(data) ? data : []);
    } catch {
      setMatchedProducers([]);
    }
  };

  const fetchProfile = async () => {
    const user = getUser();
    const token = getToken();

    try {
      const res = await fetch(`${SUPABASE_URL}/rest/v1/profiles?id=eq.${user.id}`, {
        headers: {
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (Array.isArray(data) && data[0]) {
        setProfileForm({
          full_name: data[0].full_name || '',
          bio: data[0].bio || '',
          specialties: (data[0].specialties || []).join(', '),
        });
      }
    } catch {}
  };

  const handleApply = async (eventId: string) => {
    const token = getToken();
    const event = events.find((item) => item.id === eventId);

    if (!event) {
      alert('Event not found. Please refresh and try again.');
      return;
    }

    setApplying(eventId);

    try {
      const expert = await fetchCurrentExpert();

      if (!expert) {
        throw new Error('No expert profile found for this user. Please create or approve an expert record first.');
      }

      const producerRes = await fetch(
        `${SUPABASE_URL}/rest/v1/producers?user_id=eq.${event.producer_id}&select=id&limit=1`,
        {
          headers: {
            'apikey': SUPABASE_ANON_KEY,
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      const producerData = await producerRes.json();

      if (!producerRes.ok) {
        throw new Error(producerData.message || producerData.error || 'Failed to fetch producer profile.');
      }

      const producer = Array.isArray(producerData) ? producerData[0] : null;

      if (!producer) {
        throw new Error('No producer profile found for this event. Please create a producer record for the event owner first.');
      }

      const rate = Number(expert.base_rate || extractRate(event.tier_required) || 0);
      const platformFee = 0;
      const expertPayout = rate;

      const res = await fetch(`${SUPABASE_URL}/rest/v1/bookings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${token}`,
          'Prefer': 'return=minimal',
        },
        body: JSON.stringify({
          event_id: eventId,
          expert_id: expert.id,
          producer_id: producer.id,
          status: 'applied',
          rate,
          platform_fee: platformFee,
          expert_payout: expertPayout,
          payment_status: 'pending',
        }),
      });

      if (!res.ok) {
        const errText = await res.text();

        if (errText.indexOf('bookings_event_id_expert_id_key') !== -1) {
          throw new Error('You have already applied to this event.');
        }

        throw new Error(errText || 'Failed to apply.');
      }

      setApplySuccess(eventId);
      await fetchMyBookings();
      setTimeout(() => setApplySuccess(null), 3000);
    } catch (err: any) {
      alert(err.message || 'Failed to apply.');
    }

    setApplying(null);
  };

  const handleProfileSave = async () => {
    const user = getUser();
    const token = getToken();

    setProfileSaving(true);

    try {
      await fetch(`${SUPABASE_URL}/rest/v1/profiles?id=eq.${user.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${token}`,
          'Prefer': 'return=minimal',
        },
        body: JSON.stringify({
          full_name: profileForm.full_name,
          bio: profileForm.bio,
          specialties: profileForm.specialties.split(',').map((s: string) => s.trim()).filter(Boolean),
        }),
      });

      setProfileMsg('Profile updated.');
      setTimeout(() => setProfileMsg(''), 2500);
    } catch {
      setProfileMsg('Failed to save.');
    }

    setProfileSaving(false);
  };

  const handleStripeConnect = async () => {
    const user = getUser();

    setStripeConnecting(true);

    try {
      const res = await fetch('/api/create-connect-account', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: user.email, expertId: user.id }),
      });

      const data = await res.json();

      if (data.onboardingUrl) {
        window.location.href = data.onboardingUrl;
      } else {
        alert('Stripe error: ' + (data.error || JSON.stringify(data)));
      }
    } catch (err: any) {
      alert('Network error: ' + err.message);
    }

    setStripeConnecting(false);
  };

  const handleReportSubmit = async () => {
    if (!reportBooking) return;

    const user = getUser();
    const token = getToken();

    setReportSubmitting(true);

    try {
      const res = await fetch(`${SUPABASE_URL}/rest/v1/event_reports`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${token}`,
          'Prefer': 'return=minimal',
        },
        body: JSON.stringify({
          booking_id: reportBooking.id,
          event_id: reportBooking.event_id,
          expert_id: user.id,
          producer_id: reportBooking.events?.producer_id || '',
          event_completed: reportForm.event_completed,
          actual_start_time: reportForm.actual_start_time,
          actual_end_time: reportForm.actual_end_time,
          cases_sold: parseInt(reportForm.cases_sold, 10) || 0,
          bottles_sold: parseInt(reportForm.bottles_sold, 10) || 0,
          samples_poured: parseInt(reportForm.samples_poured, 10) || 0,
          estimated_attendance: parseInt(reportForm.estimated_attendance, 10) || 0,
          skus_poured: reportForm.skus_poured,
          top_performing_sku: reportForm.top_performing_sku,
          competitor_products: reportForm.competitor_products,
          retailer_staff_engagement: reportForm.retailer_staff_engagement,
          followup_recommended: reportForm.followup_recommended,
          followup_notes: reportForm.followup_notes,
          store_manager_name: reportForm.store_manager_name,
          store_manager_confirmed: reportForm.store_manager_confirmed,
          expert_notes: reportForm.expert_notes,
          expert_rating_of_event: parseInt(reportForm.expert_rating_of_event, 10) || null,
        }),
      });

      if (res.ok) {
        setReportMsg('Report submitted successfully.');
        setReportForm({ ...EMPTY_REPORT });
        setTimeout(() => {
          setReportMsg('');
          setReportBooking(null);
        }, 2500);
      } else {
        const err = await res.text();
        setReportMsg('Error: ' + err);
      }
    } catch {
      setReportMsg('Failed to submit report.');
    }

    setReportSubmitting(false);
  };

  const alreadyApplied = (eventId: string) => bookings.some((b) => b.event_id === eventId);
  const upcomingBookings = bookings.filter((b) => b.status !== 'cancelled');
  const confirmedBookings = bookings.filter((b) => b.status === 'confirmed');
  const user = getUser();

  return (
    <div style={{ minHeight: '100vh', background: T.ink }}>
      <nav className="ex-dashboard-nav" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, padding: '0 48px', background: 'rgba(10,6,4,0.97)', borderBottom: `1px solid #1A1008` }}>
        <div className="ex-dashboard-nav-inner" style={{ maxWidth: 1100, margin: '0 auto', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 22, color: T.cream, letterSpacing: '0.08em', cursor: 'pointer' }} onClick={() => window.location.href = '/'}>SipLogic</span>
            <span style={{ width: 1, height: 12, background: T.goldMuted, display: 'inline-block' }} />
            <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 9, color: T.goldMuted, letterSpacing: '0.3em', textTransform: 'uppercase' }}>Expert Dashboard</span>
          </div>

          <div className="ex-dashboard-nav-actions" style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
            <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 9, letterSpacing: '0.2em', color: T.copper }}>{user?.email}</span>
            <button
              className="ex-sign-out"
              onClick={() => {
                localStorage.clear();
                window.location.href = '/login';
              }}
              style={{
                background: 'transparent',
                border: `1px solid ${T.goldMuted}`,
                cursor: 'pointer',
                fontFamily: "'Josefin Sans', sans-serif",
                fontWeight: 200,
                fontSize: 9,
                letterSpacing: '0.22em',
                textTransform: 'uppercase',
                color: T.creamMuted,
                padding: '7px 12px',
                whiteSpace: 'nowrap',
              }}
            >
              Sign Out
            </button>
          </div>
        </div>
      </nav>

      <div className="ex-dashboard-shell" style={{ maxWidth: 1100, margin: '0 auto', padding: '96px 24px 80px' }}>
        {!loading && (
          <div className="anim-fade-up ex-stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 2, marginBottom: 48 }}>
            <StatCard label="Open Events" value={String(events.length)} sub="Available to apply" />
            <StatCard label="My Bookings" value={String(upcomingBookings.length)} sub="Applied & confirmed" />
            <StatCard label="Matched Producers" value={String(matchedProducers.length)} sub="In your area" />
            <StatCard label="48hr Pay" value="Stripe" sub="After every event" />
          </div>
        )}

        <div className="ex-tabs" style={{ display: 'flex', gap: 2, marginBottom: 48, borderBottom: `1px solid #1A1008` }}>
          {[
            { id: 'browse', label: 'Browse Events' },
            { id: 'bookings', label: 'My Bookings' },
            { id: 'matches', label: 'Matched Producers' },
            { id: 'reports', label: 'Event Reports' },
            { id: 'profile', label: 'My Profile' },
          ].map((tab) => (
            <button key={tab.id} className={`ex-tab${view === tab.id ? ' active' : ''}`} onClick={() => setView(tab.id as any)}>
              {tab.label}
            </button>
          ))}
        </div>

        {loading && <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 17, color: T.copper, fontStyle: 'italic', textAlign: 'center', marginTop: 60 }}>Loading…</p>}

        {!loading && view === 'browse' && (
          <div className="anim-fade-up">
            <Eyebrow>Open Events · Georgia</Eyebrow>
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 32, color: T.cream, marginBottom: 32 }}>Events available to you.</h2>

            {events.length === 0 ? (
              <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 17, color: T.copper, fontStyle: 'italic' }}>No open events right now. Check back soon.</p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {events.map((event) => {
                  const applied = alreadyApplied(event.id);
                  const justApplied = applySuccess === event.id;

                  return (
                    <div key={event.id} className="ex-card">
                      <div className="ex-card-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16 }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400, fontSize: 22, color: T.cream }}>{event.title}</span>
                            <span className="ex-pill open">{event.tier_required.split(' ')[0]}</span>
                          </div>

                          <div style={{ display: 'flex', gap: 28, flexWrap: 'wrap' }}>
                            {[
                              { label: 'Date', value: new Date(event.event_date).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) },
                              { label: 'Venue', value: `${event.location_name} · ${event.city}, ${event.state}` },
                              { label: 'Category', value: event.product_category },
                              { label: 'Duration', value: `${event.duration_hours} hrs` },
                            ].map((item) => (
                              <div key={item.label}>
                                <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 8, letterSpacing: '0.3em', textTransform: 'uppercase', color: T.copper, marginBottom: 2 }}>{item.label}</div>
                                <div style={{ fontFamily: "'Crimson Pro', serif", fontSize: 15, color: T.creamMuted }}>{item.value}</div>
                              </div>
                            ))}
                          </div>

                          {event.notes && <p style={{ marginTop: 12, fontFamily: "'Crimson Pro', serif", fontSize: 14, color: T.copper, fontStyle: 'italic' }}>{event.notes}</p>}
                          <PayoutBadge tierRequired={event.tier_required} />
                        </div>

                        <div className="ex-card-action" style={{ flexShrink: 0 }}>
                          {justApplied ? (
                            <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 9, letterSpacing: '0.3em', color: T.goldMuted }}>Applied ✦</span>
                          ) : applied ? (
                            <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 9, letterSpacing: '0.3em', color: T.copper }}>Applied</span>
                          ) : (
                            <button className="ex-btn-gold" onClick={() => handleApply(event.id)} disabled={applying === event.id}>
                              {applying === event.id ? '…' : 'Apply'}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {!loading && view === 'bookings' && (
          <div className="anim-fade-up">
            <Eyebrow>Your Schedule</Eyebrow>
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 32, color: T.cream, marginBottom: 32 }}>Upcoming & applied events.</h2>

            {upcomingBookings.length === 0 ? (
              <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 17, color: T.copper, fontStyle: 'italic' }}>No bookings yet. Browse open events and apply.</p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {upcomingBookings.map((booking) => {
                  const event = booking.events;

                  return (
                    <div key={booking.id} className="ex-card">
                      <div className="ex-card-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16 }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400, fontSize: 22, color: T.cream }}>{event?.title || 'Event'}</span>
                            <span className={`ex-pill ${booking.status}`}>{booking.status}</span>
                          </div>

                          {event && (
                            <div style={{ display: 'flex', gap: 28, flexWrap: 'wrap' }}>
                              {[
                                { label: 'Date', value: new Date(event.event_date).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) },
                                { label: 'Venue', value: `${event.location_name} · ${event.city}, ${event.state}` },
                                { label: 'Category', value: event.product_category },
                                { label: 'Duration', value: `${event.duration_hours} hrs` },
                              ].map((item) => (
                                <div key={item.label}>
                                  <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 8, letterSpacing: '0.3em', textTransform: 'uppercase', color: T.copper, marginBottom: 2 }}>{item.label}</div>
                                  <div style={{ fontFamily: "'Crimson Pro', serif", fontSize: 15, color: T.creamMuted }}>{item.value}</div>
                                </div>
                              ))}
                            </div>
                          )}

                          {event && <PayoutBadge tierRequired={event.tier_required} />}
                        </div>

                        {booking.compliance_pdf_url && (
                          <div className="ex-card-action" style={{ flexShrink: 0 }}>
                            <button className="ex-btn" onClick={() => window.open(booking.compliance_pdf_url, '_blank')}>
                              Download PDF
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {!loading && view === 'matches' && (
          <div className="anim-fade-up">
            <Eyebrow>Your Network</Eyebrow>
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 32, color: T.cream, marginBottom: 8 }}>Producers & brands in Georgia.</h2>
            <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 17, color: T.copper, fontStyle: 'italic', marginBottom: 32 }}>Suppliers who post events matching your certification and specialties.</p>

            {matchedProducers.length === 0 ? (
              <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 17, color: T.copper, fontStyle: 'italic' }}>No producers found yet.</p>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 2 }}>
                {matchedProducers.map((producer) => (
                  <div key={producer.id} className="ex-card" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400, fontSize: 20, color: T.cream }}>{producer.company_name || 'Producer'}</div>
                    <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 9, letterSpacing: '0.2em', color: T.copper }}>{producer.email}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {!loading && view === 'reports' && (
          <div className="anim-fade-up">
            <Eyebrow>Post-Event Reporting</Eyebrow>
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 32, color: T.cream, marginBottom: 8 }}>File an event report.</h2>
            <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 17, color: T.copper, fontStyle: 'italic', marginBottom: 32 }}>Reports required within 48 hours of completion. Producer feedback is not shared with you.</p>

            {!reportBooking ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {confirmedBookings.length === 0 ? (
                  <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 17, color: T.copper, fontStyle: 'italic' }}>No confirmed events to report on yet.</p>
                ) : (
                  confirmedBookings.map((booking) => (
                    <div key={booking.id} className="ex-card ex-card-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400, fontSize: 20, color: T.cream, marginBottom: 4 }}>{booking.events?.title || 'Event'}</div>
                        <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 9, letterSpacing: '0.3em', textTransform: 'uppercase', color: T.copper }}>
                          {booking.events?.location_name} · {booking.events?.city}, {booking.events?.state}
                        </div>
                      </div>

                      <div className="ex-card-action">
                        <button className="ex-btn-gold" onClick={() => setReportBooking(booking)} style={{ padding: '8px 20px' }}>
                          File Report
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            ) : (
              <div style={{ maxWidth: 560 }}>
                <div className="ex-card-row" style={{ padding: '14px 20px', marginBottom: 32, background: T.surface, border: `1px solid ${T.borderMid}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 8, letterSpacing: '0.3em', textTransform: 'uppercase', color: T.copper, marginBottom: 4 }}>Filing Report For</div>
                    <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, color: T.cream }}>{reportBooking.events?.title}</div>
                  </div>

                  <button
                    onClick={() => setReportBooking(null)}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      fontFamily: "'Josefin Sans', sans-serif",
                      fontWeight: 100,
                      fontSize: 9,
                      letterSpacing: '0.3em',
                      textTransform: 'uppercase',
                      color: T.copper,
                    }}
                  >
                    ← Back
                  </button>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <input type="checkbox" checked={reportForm.event_completed} onChange={(e) => setReportForm((f) => ({ ...f, event_completed: e.target.checked }))} style={{ width: 16, height: 16, accentColor: T.goldMuted }} />
                    <label style={LabelStyle()}>Event was completed</label>
                  </div>

                  <div className="ex-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                    <div>
                      <label style={LabelStyle()}>Actual Start Time</label>
                      <input className="sl-input" type="time" value={reportForm.actual_start_time} onChange={(e) => setReportForm((f) => ({ ...f, actual_start_time: e.target.value }))} style={{ colorScheme: 'dark' }} />
                    </div>

                    <div>
                      <label style={LabelStyle()}>Actual End Time</label>
                      <input className="sl-input" type="time" value={reportForm.actual_end_time} onChange={(e) => setReportForm((f) => ({ ...f, actual_end_time: e.target.value }))} style={{ colorScheme: 'dark' }} />
                    </div>
                  </div>

                  <div className="ex-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                    {[
                      { key: 'cases_sold', label: 'Cases Sold' },
                      { key: 'bottles_sold', label: 'Bottles Sold' },
                      { key: 'samples_poured', label: 'Samples Poured' },
                      { key: 'estimated_attendance', label: 'Est. Attendance' },
                    ].map(({ key, label }) => (
                      <div key={key}>
                        <label style={LabelStyle()}>{label}</label>
                        <input className="sl-input" type="number" min="0" value={(reportForm as any)[key]} onChange={(e) => setReportForm((f) => ({ ...f, [key]: e.target.value }))} placeholder="0" />
                      </div>
                    ))}
                  </div>

                  {[
                    { key: 'skus_poured', label: 'SKUs Poured', placeholder: 'e.g. Chateau Margaux 2018, Opus One 2019' },
                    { key: 'top_performing_sku', label: 'Top Performing SKU', placeholder: 'Which product drove the most interest?' },
                    { key: 'competitor_products', label: 'Competitor Products on Shelf', placeholder: 'Notable competitor products observed' },
                  ].map(({ key, label, placeholder }) => (
                    <div key={key}>
                      <label style={LabelStyle()}>{label}</label>
                      <input className="sl-input" value={(reportForm as any)[key]} onChange={(e) => setReportForm((f) => ({ ...f, [key]: e.target.value }))} placeholder={placeholder} />
                    </div>
                  ))}

                  <div>
                    <label style={LabelStyle()}>Retailer Staff Engagement</label>
                    <div style={{ position: 'relative' }}>
                      <select className="sl-select" value={reportForm.retailer_staff_engagement} onChange={(e) => setReportForm((f) => ({ ...f, retailer_staff_engagement: e.target.value }))}>
                        <option value="">Select level…</option>
                        <option value="excellent">Excellent — actively promoted product</option>
                        <option value="good">Good — supportive and engaged</option>
                        <option value="neutral">Neutral — present but uninvolved</option>
                        <option value="poor">Poor — disengaged or unhelpful</option>
                      </select>
                      <span style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', color: T.copper, fontSize: 10, pointerEvents: 'none' }}>▾</span>
                    </div>
                  </div>

                  <div>
                    <label style={LabelStyle()}>Store Manager Name</label>
                    <input className="sl-input" value={reportForm.store_manager_name} onChange={(e) => setReportForm((f) => ({ ...f, store_manager_name: e.target.value }))} placeholder="Manager who verified the event" />
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <input type="checkbox" checked={reportForm.store_manager_confirmed} onChange={(e) => setReportForm((f) => ({ ...f, store_manager_confirmed: e.target.checked }))} style={{ width: 16, height: 16, accentColor: T.goldMuted }} />
                    <label style={LabelStyle()}>Store manager confirmed event completion</label>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <input type="checkbox" checked={reportForm.followup_recommended} onChange={(e) => setReportForm((f) => ({ ...f, followup_recommended: e.target.checked }))} style={{ width: 16, height: 16, accentColor: T.goldMuted }} />
                    <label style={LabelStyle()}>Follow-up event recommended</label>
                  </div>

                  {reportForm.followup_recommended && (
                    <div>
                      <label style={LabelStyle()}>Follow-up Notes</label>
                      <textarea className="sl-input" value={reportForm.followup_notes} onChange={(e) => setReportForm((f) => ({ ...f, followup_notes: e.target.value }))} placeholder="Why and what should be done differently?" rows={3} style={{ resize: 'none', lineHeight: 1.65 }} />
                    </div>
                  )}

                  <div>
                    <label style={LabelStyle()}>Expert Notes <span style={{ color: '#3A2A22' }}>(visible to producer)</span></label>
                    <textarea className="sl-input" value={reportForm.expert_notes} onChange={(e) => setReportForm((f) => ({ ...f, expert_notes: e.target.value }))} placeholder="Observations, recommendations, or context for the producer…" rows={4} style={{ resize: 'none', lineHeight: 1.65 }} />
                  </div>

                  <div>
                    <label style={LabelStyle()}>Rate This Event <span style={{ color: '#3A2A22' }}>(1–5)</span></label>
                    <div style={{ position: 'relative' }}>
                      <select className="sl-select" value={reportForm.expert_rating_of_event} onChange={(e) => setReportForm((f) => ({ ...f, expert_rating_of_event: e.target.value }))}>
                        <option value="">Select rating…</option>
                        {['1', '2', '3', '4', '5'].map((r) => <option key={r} value={r}>{r} — {['Poor', 'Below Average', 'Average', 'Good', 'Excellent'][parseInt(r, 10) - 1]}</option>)}
                      </select>
                      <span style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', color: T.copper, fontSize: 10, pointerEvents: 'none' }}>▾</span>
                    </div>
                  </div>

                  {reportMsg && <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 14, color: T.copperLight, fontStyle: 'italic' }}>{reportMsg}</p>}

                  <button className="ex-btn-gold" onClick={handleReportSubmit} disabled={reportSubmitting} style={{ width: '100%', padding: '16px' }}>
                    {reportSubmitting ? 'Submitting…' : 'Submit Report'}
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {!loading && view === 'profile' && (
          <div className="anim-fade-up" style={{ maxWidth: 560 }}>
            <Eyebrow>Your Credentials</Eyebrow>
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 32, color: T.cream, marginBottom: 32 }}>Expert profile.</h2>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
              <div>
                <label style={LabelStyle()}>Full Name</label>
                <input className="sl-input" value={profileForm.full_name} onChange={(e) => setProfileForm((f) => ({ ...f, full_name: e.target.value }))} placeholder="Jane Smith MS" />
              </div>

              <div>
                <label style={LabelStyle()}>Specialties <span style={{ color: '#3A2A22' }}>(comma separated)</span></label>
                <input className="sl-input" value={profileForm.specialties} onChange={(e) => setProfileForm((f) => ({ ...f, specialties: e.target.value }))} placeholder="Bordeaux & Burgundy, American Whiskey, Tequila & Mezcal" />
              </div>

              <div>
                <label style={LabelStyle()}>Professional Bio</label>
                <textarea className="sl-input" value={profileForm.bio} onChange={(e) => setProfileForm((f) => ({ ...f, bio: e.target.value }))} placeholder="Your background, certifications, and what makes you exceptional at retail tastings…" rows={4} style={{ resize: 'none', lineHeight: 1.65 }} />
              </div>

              <div style={{ padding: '20px 24px', border: '1px solid #3A2A18', background: '#0E0C06' }}>
                <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 8, letterSpacing: '0.4em', textTransform: 'uppercase', color: T.copper, marginBottom: 8 }}>Stripe Payouts</div>
                <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 15, color: T.copper, fontStyle: 'italic', lineHeight: 1.65, marginBottom: 16 }}>Connect your Stripe account to receive payouts within 48 hours of each completed event.</p>
                <button className="ex-btn-gold" onClick={handleStripeConnect} disabled={stripeConnecting} style={{ padding: '10px 24px' }}>
                  {stripeConnecting ? 'Connecting…' : 'Connect Stripe Account'}
                </button>
              </div>

              {profileMsg && <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 14, color: T.copperLight, fontStyle: 'italic' }}>{profileMsg}</p>}

              <button className="ex-btn-gold" onClick={handleProfileSave} disabled={profileSaving} style={{ width: '100%', padding: '16px' }}>
                {profileSaving ? 'Saving…' : 'Save Profile'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}